import {SessionNaming} from "./SessionNaming";
import SessionPlayerManagement from "./SessionPlayerManagement";
import { useSelector } from "react-redux";
import PermissionViewable from "../PermissionedComponents/PermissionViewable";


export const SessionManagement = () => {

      const {
        info: {
          permissions_manager_list: permissionsManagerList,
        }
      } = useSelector(({ team }) => team);

      const permissionMessage = (
        <div>
          You do not have permissions to manage GPS training sessions. <br/> 
          If you want to add/remove specific permissions to your account, please reach out to your team's permissions manager. <br/><br/>
          Your team's Permissions Manager(s): <strong>{permissionsManagerList.map(user => `${user.first_name} ${user.last_name}`).join(", ")}</strong>
        </div>
      );
       

  return (
    <PermissionViewable 
        permissionCheck="ManageGPSTrainingSessions"
        permissionMessage={permissionMessage}
        tooltipMessage="This page requires special permissions"
        >
            <SessionNaming />
            <div style={{ marginTop: '3em' }} ></div>
            <SessionPlayerManagement />
    </PermissionViewable>
  );
}